module.exports = __webpack_public_path__ + "static/rooh-9dafe463fadd76ac6e3ac5edea1ffd54.png";